import Web3 from "web3";
import { createWalletClient, custom } from 'viem';

const getWeb3 = (config) => new Promise((resolve) => {

    const selectedProvider = localStorage.getItem("selectedProvider");

    if (selectedProvider === "metamask") {

        console.log("web3.js metamask")

        if (window.ethereum && window.ethereum.isMetaMask) {

            const currentWeb3 = new Web3(window.ethereum);
            currentWeb3.getAccounts = currentWeb3.eth.getAccounts;

            const walletClient = createWalletClient({
                transport: custom(window.ethereum)
            });
            currentWeb3.walletClient = walletClient;

            resolve({w3:currentWeb3, ethereum:window.ethereum});

        }

    } else if (window.ethereum) {

        console.log('web3.js using default window.ethereum provider')
        const currentWeb3 = new Web3(window.ethereum);

        const walletClient = createWalletClient({
            transport: custom(window.ethereum)
        });
        currentWeb3.walletClient = walletClient;

        resolve({w3:currentWeb3, ethereum:window.ethereum});

    } else {

        console.log('web3.js using fallback HTTP provider')
        console.log(config.VUE_APP_PROVIDER);

        const currentWeb3 = new Web3(new Web3.providers.HttpProvider(config.VUE_APP_PROVIDER));

        resolve({w3:currentWeb3, ethereum:null});

    }

});

export {getWeb3};
